import React from 'react';

import { NextPageWithLayout } from 'next';

import { InternalLink } from '../../../components/Clickables/InternalLink/InternalLink';
import { Container } from '../../../components/Container/Container';
import { Heading } from '../../../components/Heading/Heading';
import { MetaTags } from '../../../components/MetaTags/MetaTags';

import { BrandPostsGrid } from './components/BrandPostsGrid';
import { FilteredBrands } from './FilteredBrands/FilteredBrands';

export const DiscoverBrands: NextPageWithLayout = () => (
  <div>
    <MetaTags
      title="Top Fishing Brands"
      description="View the most popular fishing brands and retailers. See what your favorite brands are up to on Fishbrain."
      link="/brands"
    />
    <Container className="flex flex-col justify-between sm:flex-row sm:items-end">
      <Heading as="h1" variant="xl" className="mb-4">
        Brands
      </Heading>
      <InternalLink to="/brands/all" variant="buttonPrimary" className="mb-4">
        View all brands
      </InternalLink>
    </Container>

    <FilteredBrands variant="FeaturedBrand" title="Popular Brands" />
    <FilteredBrands variant="ActiveBrand" title="Recently Active Brands" />

    <Container className="mb-8 space-y-8">
      <BrandPostsGrid />
    </Container>
  </div>
);
